import styled from 'styled-components';
import SbAvatar from 'uiCore/SbAvatar/SbAvatar';

// Page container with max-width and centered padding
export const PageWrapperStyled = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

// Avatar with color palette cycling based on index
export const FunctionAvatarStyled = styled(SbAvatar)`
  && {
    background-color: ${p => {
      const palette = [
        p.theme?.colors?.primary,
        p.theme?.colors?.info,
        p.theme?.colors?.statusProcessing,
        p.theme?.colors?.success,
        p.theme?.colors?.danger,
        p.theme?.colors?.gray,
        p.theme?.colors?.dark,
        p.theme?.colors?.tertiary,
      ];
      return palette[p.$index % palette.length] ?? p.theme?.colors?.primary;
    }};
    flex-shrink: 0;
  }
`;

// Input wrapper with fixed width bounds
export const InputWrapperStyled = styled.div`
  min-width: 220px;
  max-width: 320px;
`;

// Page footer with top border separator
export const FooterStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${p => p.theme?.colors?.border ?? '#D8DAE5'};
`;
